module.exports = __webpack_public_path__ + "img/academy_resillience.bb43814a.png";